module.exports = __webpack_public_path__ + "img/glass-half.68713d81.svg";